export default "__VITE_ASSET__CDtElxgy__"